import styled from 'styled-components';

export const PurpleColor = styled.span`
	color: #9965f4;
`;

export const IconPrentendLogout = styled.div`
	display: inline-block;
	width: 20px;
	height: 20px;
	vertical-align: bottom;
	margin-right: 8px;
`;

export const Button = styled.div`
	font-weight: bold;
	font-size: 14px;
	line-height: 20px;
	color: rgba(9, 21, 38, 0.35);
	cursor: pointer;
	&:hover {
		color: rgba(9, 21, 38, 0.65);
		${IconPrentendLogout} path {
			fill: rgba(9, 21, 38, 0.85);
		}
	}
	${IconPrentendLogout} path {
		fill: rgba(9, 21, 38, 0.35);
	}
`;
